import { setStatus, deleteProfiles } from "../../lib/adminApi";

export const BULK = {
  approve: {
    id: "approve", label: "Approve", perm: "can_approve",
    confirm: (n) => ({ title: `Approve ${n} profile(s)?`, description: "Approved profiles can be shared with clients." }),
    run: (ids) => setStatus(ids, "approved"),
  },
  reject: {
    id: "reject", label: "Reject", perm: "can_approve",
    confirm: (n) => ({ title: `Reject ${n} profile(s)?`, description: "A reason is required and is saved on each profile.", needsReason: true }),
    run: (ids, reason) => setStatus(ids, "rejected", reason),
  },
  hold: {
    id: "hold", label: "Hold", perm: "can_approve",
    confirm: (n) => ({ title: `Put ${n} profile(s) on hold?`, description: "Profiles on hold stay hidden until reviewed again.", reasonOptional: true }),
    run: (ids, reason) => setStatus(ids, "hold", reason),
  },
  block: {
    id: "block", label: "Block", perm: "can_approve",
    confirm: (n) => ({ title: `Block ${n} profile(s)?`, description: "Blocked clients lose access to their account immediately.", reasonOptional: true }),
    run: (ids, reason) => setStatus(ids, "blocked", reason),
  },
  delete: {
    id: "delete", label: "Delete", perm: "can_edit",
    confirm: (n) => ({ title: `Permanently delete ${n} profile(s)?`, description: "This removes the profile, family, private, office details, photos, ID proofs, notes and shares. This cannot be undone." }),
    run: (ids) => deleteProfiles(ids),
  },
};
